<app-menu></app-menu>
<div style="background-color: #ffffff;">
    <div class="fundo-sobre uk-light">
        <div class="uk-container uk-text-center">
            <h1 class="hero-standard-title" uk-scrollspy="cls: uk-animation-slide-top-small; delay: 100">Sobre a Fluxodigital</h1>
            <p class="uk-text-large" style="opacity: 0.9;" uk-scrollspy="cls: uk-animation-slide-bottom-small; delay: 300">Um passo a frente para o futuro!</p>
        </div>
    </div>
</div>

<!-- Mission Section -->
<div class="uk-section uk-section-muted">
    <div class="uk-container">
        <div class="uk-grid uk-grid-match" uk-grid>
            <!-- About Text (Left) -->
            <div class="uk-width-2-3@m" uk-scrollspy="cls: uk-animation-slide-left-small; delay: 100">
                <div class="about-card uk-height-1-1">
                    <h2 class="mission-header title-highlight">Nossa História & Missão</h2>
                    <div class="section-content">
                        <p>
                            A <strong>Fluxodigital</strong> foi fundada com uma visão clara: ser a ponte entre o presente e o futuro tecnológico. 
                            Somos apaixonados por inovação e dedicados a fornecer soluções que impulsionam o sucesso dos nossos clientes.
                        </p>
                        <div class="quote-box">
                            "Nossa missão é transformar ideias em realidades digitais, criando experiências que superam as expectativas."
                        </div>
                        <p>
                            Nossos serviços são desenvolvidos com alta tecnologia, focados em otimizar custos e garantir a máxima eficiência operacional 
                            para empresas que buscam se destacar no mercado competitivo de hoje.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Timeline Cards (Right) -->
            <div class="uk-width-1-3@m" uk-scrollspy="cls: uk-animation-slide-right-small; delay: 200">
                <div class="uk-flex uk-flex-column uk-height-1-1">
                    <div class="milestone-card">
                        <span class="milestone-year">2017</span>
                        <p style="opacity: 0.8; font-size: 0.9rem; margin: 0;">
                            Fundação da Fluxodigital e início da jornada tecnológica.
                        </p>
                    </div>

                    <div class="milestone-card" uk-scrollspy="cls: uk-animation-slide-right-small; delay: 400">
                        <span class="milestone-year">2022</span>
                        <p style="opacity: 0.8; font-size: 0.9rem; margin: 0;">
                            Expansão estratégica e consolidação do portfólio de serviços.
                        </p>
                    </div>

                    <div class="milestone-card" uk-scrollspy="cls: uk-animation-slide-right-small; delay: 600">
                        <span class="milestone-year">2026</span>
                        <p style="opacity: 0.8; font-size: 0.9rem; margin: 0;">
                            Liderança em infraestrutura digital disruptiva e resiliente.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Recognitions Section -->
<div class="uk-section uk-section-muted uk-padding-remove-vertical">
    <div class="uk-container uk-text-center">
        <div class="uk-margin-small-top" uk-scrollspy="cls: uk-animation-scale-up; delay: 200">
            <img src="img/certificacao.png" alt="femTECH e Acelera NET 2.0" 
                 class="cert-float"
                 style="max-height: 140px; width: auto; filter: drop-shadow(0 10px 20px rgba(0,0,0,0.05));">
        </div>
    </div>
</div>


<!-- Values Section -->
<div class="uk-section uk-section-default">
    <div class="uk-container">
        <div class="uk-text-center uk-margin-large-bottom" uk-scrollspy="cls: uk-animation-slide-top-small; delay: 100">
            <h2 class="uk-text-bold title-highlight">Nossos Valores</h2>
            <p class="uk-text-large" style="color: #666;">O que nos distingue e guia cada uma de nossas decisões.</p>
        </div>

        <div class="uk-grid-small uk-child-width-1-4@l uk-child-width-1-2@m uk-child-width-1-1@s" uk-grid uk-scrollspy="cls: uk-animation-slide-bottom-small; target: > div; delay: 150">
            <div>
                <div class="value-card">
                    <div class="value-icon"><span uk-icon="icon: check; ratio: 1.5"></span></div>
                    <h3 class="uk-text-bold">Excelência</h3>
                    <p class="uk-text-small">Busca constante pela perfeição em cada detalhe técnico e humano.</p>
                </div>
            </div>
            <div>
                <div class="value-card">
                    <div class="value-icon"><span uk-icon="icon: user; ratio: 1.5"></span></div>
                    <h3 class="uk-text-bold">Competência</h3>
                    <p class="uk-text-small">Equipe qualificada e processos robustos para entregar o melhor.</p>
                </div>
            </div>
            <div>
                <div class="value-card">
                    <div class="value-icon"><span uk-icon="icon: star; ratio: 1.5"></span></div>
                    <h3 class="uk-text-bold">Disrupção</h3>
                    <p class="uk-text-small">Inovação que quebra paradigmas e cria novos caminhos digitais.</p>
                </div>
            </div>
            <div>
                <div class="value-card">
                    <div class="value-icon"><span uk-icon="icon: cog; ratio: 1.5"></span></div>
                    <h3 class="uk-text-bold">Profissionalismo</h3>
                    <p class="uk-text-small">Ética, comprometimento e transparência em todas as relações.</p>
                </div>
            </div>
        </div>
    </div>
</div>

<app-rodape></app-rodape>


